// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"02d73ebb","496":"7d3cf0e4"}[chunkId] + ".chunk.js";
};